// src/components/ResetPassword.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../Services/supabaseClient";
import "./resetPassword.css";
import logo from "../components/Images/KostPadi-Icon.png";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // 1) Ask Supabase to send a reset link. (UNCHANGED)
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/ResetPasswordUpdate",
    });

    setLoading(false);

    // 2) Keep original alert + navigation behavior (UNCHANGED)
    if (error) {
      alert("Error sending reset email: " + error.message);
    } else {
      alert(
        "A reset link has been sent to your email. Please check your inbox."
      );
      navigate("/login");
    }
  };

  return (
    <div className="auth-layout reset-layout">
      {/* Left: brand/value (matches Login/Signup style) */}
      <aside className="auth-aside">
        <div className="brand-head">
          <img src={logo} alt="KostPadi" />
          <h1>KostPadi</h1>
        </div>
        <p className="tagline">
          A modern SME finance suite—estimate costs, invoice faster, and stay on
          top of cash flow.
        </p>

        <ul className="pill-list">
          <li>VAT/WHT-aware</li>
          <li>Estimate → Invoice</li>
          <li>Supabase RLS</li>
          <li>Export CSV/PDF</li>
        </ul>

        <div className="aside-footer">
          <a href="/" className="aside-link">
            ← Back to site
          </a>
        </div>
      </aside>

      {/* Right: card with form */}
      <main className="auth-main">
        <div className="reset-card">
          <header className="reset-head">
            <img src={logo} alt="KostPadi Logo" className="reset-logo" />
            <div>
              <h2>Reset your password</h2>
              <p className="muted">
                Enter the email associated with your account.
              </p>
            </div>
          </header>

          <form onSubmit={handleSubmit} className="reset-form">
            <label className="input-group">
              <span>Email</span>
              <input
                type="email"
                placeholder="you@company.com"
                className="reset-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </label>

            <button type="submit" className="reset-btn" disabled={loading}>
              {loading ? "Sending…" : "Send reset link"}
            </button>

            <button
              type="button"
              className="back-btn"
              onClick={() => navigate("/login")}
            >
              ← Back to log in
            </button>

            <p className="tiny-note">
              We’ll send a secure link to reset your password. If you don’t see
              it, check your spam folder.
            </p>
          </form>
        </div>
      </main>
    </div>
  );
};

export default ResetPassword;
